import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/shared/Header';
import Footer from './components/shared/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceTypes from './pages/ServiceTypes';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import Quote from './pages/Quote';
import SoftwareEngineerIntern from './pages/careers/SoftwareEngineerIntern';
import './App.css';
import ScrollToTop from './components/shared/ScrollToTop';
import ChatBotPopup from './components/shared/ChatBotPopup';
import Products from './pages/Products';
import CookiesPopup from './components/shared/CookiesPopup';
import Login from './pages/Login';
import Register from './pages/Register';
import Packages from './pages/Packages';

function App() {
  return (
    <Router>
      <ScrollToTop /> 
      <div className="min-h-screen bg-gray-50">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/products/:productId" element={<Products />} />
          <Route path="/services/:serviceType" element={<ServiceTypes />} />
          <Route path="/careers" element={<Careers />} /> 
          <Route path="/contact" element={<Contact />} /> 
          <Route path="/quote" element={<Quote />} /> 
          <Route path="/login" element={<Login />} /> 
          <Route path="/register" element={<Register />} /> 
          <Route path="/packages" element={<Packages />} /> 

          {/* Career Pages */}
          <Route path="/careers/software-engineer" element={<SoftwareEngineerIntern />} />
        </Routes>
        <ChatBotPopup />
        <Footer />
        <CookiesPopup />
      </div>
    </Router>
  );
}

export default App;
